import app from '@/app';
import templateUrl from './reinforcementCalculation-search.html';

/* @ngInject */
function ReinforcementCalculationSearchController(
	$controller,
	$state,
	DialogService,
	ReinforcementCalculation,
	Principal,
	$http,
	AlertService
) {
	var $ctrl = this;
	var resource = ReinforcementCalculation;
	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	var transition = $ctrl.transition;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$ctrl.transition = params => {
		transition(params);
		$ctrl.road = $ctrl.allRoads.content.find(it => it.id == params.road);
		$ctrl.campaigns = _.flow(
			_.keyBy('id'),
			_.at(params.campaigns || [])
		)($ctrl.allCampaigns.content);
		$http.get('api/projects', { params: { onlyUsed: true } }).then(function(response) {
			$ctrl.allProjects = response.data.content;
		});
		resource.query(
			{
				plantype: 'REINFORCEMENT',
				road: params.road,
				campaign: params.campaign,
				sort: params.sort,
				page: params.page,
				size: params.size,
				project: params.project,
				situationReinforcement: params.situationReinforcement
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
		$ctrl.roadtype = params.roadtype;
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

	$ctrl.onQueryChange = () => {
		$state.go(
			$state.current,
			{
				page: 0,
				road: $ctrl.road.id,
				campaigns: $ctrl.campaigns.map(it => it.id),
				plantype: 'REINFORCEMENT',
				project: $ctrl.project ? $ctrl.project.id : null,
				situationReinforcement: $ctrl.situationReinforcement
			},
			{
				reload: true
			}
		);
	};

	$ctrl.clearUiSelect = function($event, $select, field) {
		$event.stopPropagation();
		$select.selected = null;
		$select.search = null;

		field = null;
	};

	$ctrl.remove = id => {
		var entity = $ctrl.entities.find(e => e.id === id);
		resource.remove({ id: id }, () => {
			AlertService.success('entity.delete.message', {
				type: 'reinforcementCalculation',
				name: entity ? entity.name : ''
			});
			$state.reload();
		});
	};
}

app.component('reinforcementCalculationSearch', {
	templateUrl,
	controller: ReinforcementCalculationSearchController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<',
		allDecisionTrees: '<',
		allCostTables: '<'
	}
});
